import { CustomPaging } from "@/app/components/swipersComponents";
import React, { useState } from "react";
import { GrNext, GrPrevious } from "react-icons/gr";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

interface AdvantageCardProps {
  icon: string;
  title: string;
  content: string;
  className?: string;
}

const AdvantageCard: React.FC<AdvantageCardProps> = ({
  icon,
  title,
  content,
  className,
}) => {
  return (
    <div
      className={
        "w-full max-lg:p-3 h-96 sm:h-72 md:h-48 lg:h-full " + className
      }
    >
      <div
        className={`flex flex-col grow shrink  justify-center p-6 rounded-2xl bg-neutral-700 w-full shadow-[0px_4px_4px_rgba(0,0,0,0.25)]`}
      >
        <div className="flex flex-col justify-center py-1.5 w-full text-xl tracking-tight leading-none">
          <img
            loading="lazy"
            src={icon}
            alt=""
            className="object-contain self-center aspect-[1.22] w-[55px]"
          />
          <div className="mt-1.5">{title}</div>
        </div>
        <div className="py-1.5 w-full text-sm leading-6">{content}</div>
      </div>
    </div>
  );
};

const Advantages: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  function SampleNextArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute h-fit bg-gray-500 text-neutral-100 p-2 px-3 w-fit rounded-full inset-0 mt-auto ml-auto -mb-10 sm:-mb-16"
        }
        onClick={onClick}
      >
        <GrNext size={16} />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute z-20 bg-gray-500 text-neutral-100 p-2 px-3 w-fit h-fit rounded-full inset-0 mt-auto mr-auto -mb-10 sm:-mb-16"
        }
        onClick={onClick}
      >
        <GrPrevious size={16} />
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-consorcio" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const advantagesData = [
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Cashback.svg",
      title: "Cashback Toyota",
      content:
        "Parte do valor da carta de crédito volta para você usar em acessórios, documentação ou revisão na sua concessionária Toyota. O Cashback também pode ser usado para locação de veículos com a Kinto Sahre.",
      className: "col-span-3",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Concierge.svg",
      title: "Concierge",
      content:
        "Um time de especialistas que auxilia sobre as documentações necessárias para a aquisição do carro, agilizando a entrega.",
      className: "col-span-3",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Comunica%C3%A7%C3%A3o.svg",
      title: "Comunicação Digital",
      content:
        "Todas as etapas de faturamento acontecem digitalmente, o que torna o processo muito mais rápido.",
      className: "col-span-3",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Atendimento.svg",
      title: "Atendimento Humanizado",
      content:
        "Quando você tem dúvidas, a equipe de especialista está disponível",
      className: "col-span-3",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Prazo.svg",
      title: "Mais Prazo",
      content: "Pague seu plano de Consórcio em até 120 meses.",
      className: "col-span-2",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Vantagens=Carro.svg",
      title: "Carros 0km & Seminovos",
      content:
        "As cartas de crédito contemplam toda a linha de carros Toyota 0km. Além disso, você pode utilize-las para comprar seminovos com até 10 anos de uso.",
      className: "col-span-4",
    },
  ];

  return (
    <section className="flex flex-wrap gap-4 items-start py-4 mt-4 w-full text-zinc-600 max-md:max-w-full">
      <div className="flex flex-col grow shrink text-4xl leading-tight text-center max-md:max-w-full">
        <h2 className="w-full max-md:max-w-full">
          Vantagens do ConsórcioToyota
        </h2>
      </div>
      <p className="grow shrink text-lg leading-6  max-md:max-w-full">
        Confira alguns motivos para você escolher o Consórcio da maior montadora
        de veículos do mundo.
      </p>
      <div className="flex flex-col grow shrink text-center text-white w-[524px] max-md:max-w-full">
        <div className="grid grid-cols-6 gap-4 col-span-2 items-start w-full max-md:max-w-full max-lg:hidden">
          {advantagesData.map((advantage, index) => (
            <AdvantageCard
              key={"paging.advantagesConsorcio.card" + index}
              icon={advantage.icon}
              title={advantage.title}
              content={advantage.content}
              className={advantage.className}
            />
          ))}
        </div>
        <div className="w-full customSlickFlex lg:hidden mb-20">
          <Slider {...settings}>
            {advantagesData.map((advantage, index) => (
              <AdvantageCard
                key={"paging.advantagesConsorcio.card.mbl" + index}
                icon={advantage.icon}
                title={advantage.title}
                content={advantage.content}
                className={advantage.className}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
